<script>
import { mapState, mapMutations } from "vuex";
import LimitedWarranty from "@/components/ContractModals/Components/BaseParts/LimitedWarranty";

export default {
  extends: LimitedWarranty,
  computed: {
    ...mapState("QuotationContractModal", ["limitedWarranty", "ticketType"])
  },
  methods: {
    ...mapMutations("QuotationContractModal", [
      "setLimitedWarrantyLabourQuantity",
      "setLimitedWarrantyUnitsOne",
      "setLimitedWarrantyHourlyPrice",
      "setLimitedWarrantyUnitsTwo",
      "setLimitedWarrantyTerm"
    ])
  }
};
</script>
